import React from 'react';
import * as S from './styles';

type OwnProps = {
  className?: string;
  imgUrl?: string | null;
  title: string;
  link?: string;
  year?: string;
  type?: 'soty' | 'default';
};

const Card = ({
  className,
  imgUrl,
  year,
  title,
  link,
  type = 'default',
}: OwnProps) => {
  const renderCardImage = () => {
    if (!imgUrl) return null;

    return type === 'soty' ? (
      <S.SotyBadge imgUrl={imgUrl} name={title} year={year} />
    ) : (
      <S.Image>
        <S.ImageWrapper>
          <img src={imgUrl} alt={title} title={title} />
        </S.ImageWrapper>
      </S.Image>
    );
  };

  const renderCardContent = () => (
    <>
      {renderCardImage()}
      <S.Title>{title}</S.Title>
      {year && <S.Subtitle>{year}</S.Subtitle>}
    </>
  );

  return (
    <S.Card className={className}>
      {link ? (
        <S.Link to={link}>{renderCardContent()}</S.Link>
      ) : (
        <S.Content>{renderCardContent()}</S.Content>
      )}
    </S.Card>
  );
};

export default Card;
